import moment from 'moment-timezone';

// The API returns dates as ISO 8601 strings carrying the region's UTC offset,
// e.g. "2026-12-08T22:00:00+01:00" for an event starting at 22:00 in Basel.
// Events are always shown in the region's time, not in the time zone of the browser

const WALL_CLOCK_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const formatRegionDate = (value, format) => {
    if (!value) {
        return "";
    }
    return moment.parseZone(value).format(format);
};

// The date pickers only know about the browser's time zone, so we hand them a date whose *local* wall clock matches the region's one.
export const toPickerDate = (value) => {
    if (!value) {
        return null;
    }
    return moment(moment.parseZone(value).format(WALL_CLOCK_FORMAT)).toDate();
};

// Inverse of toPickerDate: take the wall clock the user picked and pin it to the region's time zone (which gives the correct offset for that date, DST included).
export const fromPickerDate = (date, timeZone) => {
    // The pickers call input.onBlur() without a value right after onChange, and redux-form runs parse() on that too.
    // Returning undefined leaves the value alone, whereas null would immediately wipe what was just picked.
    if (date === undefined) {
        return undefined;
    }
    if (!date) {
        return null;
    }
    const wallClock = moment(date).format(WALL_CLOCK_FORMAT);
    if (!timeZone) {
        return moment(wallClock).format();
    }
    return moment.tz(wallClock, timeZone).format();
};
